/// <amd-module name="Analytics/Shared/PowerbiClient/RestClient/Powerbi" />
/**
 * ---------------------------------------------------------
 * Generated file, DO NOT EDIT
 * ---------------------------------------------------------
 *
 * See following wiki page for instructions on how to regenerate:
 *   https://aka.ms/azure-devops-client-generation
 *
 * Configuration file:
 *   tfs\web\extensions\analytics\vss-analyticsshared-web\shared\powerbi\powerbiclient\powerbi.genclient.json
 */

import { IVssPageContext, IVssRestClient, IVssRestClientOptions, RestClients } from "VSS/Platform/Context";
import { RestClientBase } from "VSS/Platform/RestClientBase";

import * as Powerbi from "Analytics/Shared/PowerbiClient/Contracts/Powerbi";

export interface IPowerbiRestClient extends IVssRestClient {
    /**
     * @param project - Project ID or project name
     * @param groupName - 
     * @param reportName - 
     * @param accessToken - Header to pass the access token
     */
    getReport(project: string, groupName: string, reportName: string, accessToken: String): Promise<Powerbi.PowerBiReportDetails>;
}

class PowerbiRestClient extends RestClientBase implements IPowerbiRestClient {
    constructor(options: IVssRestClientOptions) {
        super(options);
    }

    /**
     * @param project - Project ID or project name
     * @param groupName - 
     * @param reportName - 
     * @param accessToken - Header to pass the access token
     */
    public async getReport(
        project: string,
        groupName: string,
        reportName: string,
        accessToken: String
        ): Promise<Powerbi.PowerBiReportDetails> {

        return this.beginRequest<Powerbi.PowerBiReportDetails>({
            apiVersion: "5.1-preview.1",
            routeTemplate: "{project}/_apis/powerbi/Report/{groupName}/{reportName}",
            routeValues: {
                project: project,
                groupName: groupName,
                reportName: reportName
            },
            customHeaders: {
                "x-ms-accessToken": accessToken,
            }
        });
    }

}

export const PowerbiClientName = "IPowerbiRestClient";

export function getPowerbiClient(pageContext: IVssPageContext, options?: IVssRestClientOptions): IPowerbiRestClient {
    return pageContext.getRestClient<IPowerbiRestClient>(PowerbiClientName, options);
}

RestClients.add(PowerbiClientName, { 
    factory: PowerbiRestClient,
    options: {
        resourceAreaId: "e02c4297-9916-457f-a15a-0f835551dc3f",
        serviceInstanceType: "00025394-6065-48ca-87d9-7f5672854ef7"
    }
});
